module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_j_leucistic.ae1dd451.png";